import React, { useState, useEffect } from 'react';
import { PhoneCall, House, Mail } from 'lucide-react';
import '../styles/about-mnh.css';
import '../styles/about.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPeopleGroup, faTrophy, faCalendar, faBriefcaseMedical, faUserDoctor, faAward, faCirclePlus, faAlarmClock } from '@fortawesome/free-solid-svg-icons';

function About() {
  // Animated counter for Happy Customers
  const [customerCount, setCustomerCount] = useState(0);
  const [programsCount, setProgramsCount] = useState(0);
  const [experienceCount, setExperienceCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const end = 1050;
    const duration = 1200; // ms
    const stepTime = Math.max(Math.floor(duration / end), 1);
    let current = start;
    const timer = setInterval(() => {
      current += Math.ceil(end / (duration / stepTime));
      if (current >= end) {
        current = end;
        clearInterval(timer);
      }
      setCustomerCount(current);
    }, stepTime);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    let start = 0;
    const end = 10;
    const duration = 900; // ms
    const stepTime = Math.max(Math.floor(duration / end), 1);
    let current = start;
    const timer = setInterval(() => {
      current += Math.ceil(end / (duration / stepTime));
      if (current >= end) {
        current = end;
        clearInterval(timer);
      }
      setProgramsCount(current);
    }, stepTime);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    let start = 0;
    const end = 20;
    const duration = 900; // ms
    const stepTime = Math.max(Math.floor(duration / end), 1);
    let current = start;
    const timer = setInterval(() => {
      current += Math.ceil(end / (duration / stepTime));
      if (current >= end) {
        current = end;
        clearInterval(timer);
      }
      setExperienceCount(current);
    }, stepTime);
    return () => clearInterval(timer);
  }, []);
  return (
    <>
      <div className="about-container">
        <img
          src={require("../assets/img/chember.png")}
          alt="ICU"
          className="about-icu-img"
          style={{ width: '100%', height: '600px' }}
        />
        <div className="gallery-overlay-title" style={{ top: '70%' }}>
          Compassionate Care,
          <p style={{ fontWeight: 'normal', fontSize: '40px', color: '#FFFFFF', textAlign: 'center' }}>Modern Medicine, Trusted Expertise</p>
        </div>
      </div>
      <div className="home-carousel-row">
        <div className="home-carousel-col">
          <div className="carousel-col-content">
            <PhoneCall size={48} color="#fff" />
            <span className="carousel-col-title">
              In Emergency give us a call<br />
              9434007688
            </span>
          </div>
        </div>
        <div className="home-carousel-col">
          <div className="carousel-col-content">
            <House size={48} color="#fff" />
            <span className="carousel-col-title">
              Get our Location<br />
              Dangalpara, Suri, Birbhum
            </span>
          </div>
        </div>
        <div className="home-carousel-col">
          <div className="carousel-col-content">
            <Mail size={48} color="#fff" />
            <span className="carousel-col-title">
              Send an email<br />
              mdnhsuribir@gmail.com
            </span>
          </div>
        </div>
      </div>
      <div className="about-extra-section" style={{ marginTop: '50px' }}>
        <h1 style={{ marginLeft: '80px' }}>About Modern Diagnostics & Nursing Home Pvt. Ltd.</h1>
        <div className="about-extra-row">
          <div className="col1 about-extra-col">
            <p style={{ fontWeight: '600', textAlign: 'justify' }}>Modern Diagnostics & Nursing Home Pvt. Ltd. is a healthcare facility located in Dangalpara, Suri, Birbhum. Established in 2002, we have been providing diagnostic, medical, and surgical care to patients for over two decades.</p>
            <p style={{ textAlign: 'justify' }}>At Modern Diagnostics & Nursing Home Pvt. Ltd., we offer outpatient (OPD) consultations, diagnostic services, and a range of medical and surgical treatments. Our team ensures proper medical and nursing aftercare, with a strong focus on patient safety, comfort, and recovery.</p>
            <h2>Why Choose Us</h2>
            <ul className="about-why-list">
              <li>Established in 2002, providing trusted healthcare services for over two decades</li>
              <li>A team of qualified and experienced doctors across multiple medical specialties</li>
              <li>Well-equipped diagnostic, medical, and surgical facilities to support accurate and timely treatment</li>
              <li>A strong commitment to ethical medical practices and patient-centred care.</li>
            </ul>
            <h2>Our Facilities</h2>
            <p>Our facility is supported by essential medical infrastructure to ensure timely diagnosis, safe treatment, and proper patient care. We offer 24×7 emergency ambulance services, CT scan and X-ray facilities, round-the-clock laboratory services, well-equipped operation theatres, and dedicated nursing support for admitted patients. Mediclaim assistance and dietician services are also available to support patient recovery.</p>
          </div>
          <div className="col2 about-extra-col">
            <img
              src={require("../assets/img/ICU.jpeg")}
              alt="ICU"
              style={{ width: '100%', height: 'auto', borderRadius: '8px' }}
            />
          </div>
        </div>
      </div>
      <section className='info-band'>
        <div className="info-band-row">
          <div className="info-band-col info-band-col-center">
            <FontAwesomeIcon icon={faPeopleGroup} size="6x" style={{ color: '#78a6bf' }} />
            <div className="info-band-number">{customerCount}</div>
            <div className="info-band-title">Happy Customers</div>
          </div>
          <div className="info-band-col info-band-col-center">
            <FontAwesomeIcon icon={faTrophy} size="6x" style={{ color: '#78a6bf' }} />
            <div className="info-band-number">{programsCount}</div>
            <div className="info-band-title">Our Programs</div>
          </div>
          <div className="info-band-col info-band-col-center">
            <FontAwesomeIcon icon={faCalendar} size="6x" style={{ color: '#78a6bf' }} />
            <div className="info-band-number">{experienceCount}</div>
            <div className="info-band-title">Years of Experience</div>
          </div>
          <div className="info-band-col info-band-col-center">
            <FontAwesomeIcon icon={faBriefcaseMedical} size="6x" style={{ color: '#78a6bf' }} />
            <div className="info-band-number">14</div>
            <div className="info-band-title">Best Doctors</div>
          </div>
        </div>
      </section>
      <section className='achiv-band' style={{ backgroundColor: '#d7e1e4', marginTop: '50px', marginBottom: '50px', padding: '20px' }}>
        <h3 style={{ marginTop: '20px', marginLeft: '80px' }}><FontAwesomeIcon icon={faAward} size='48px' />Clinical Achievement Highlight</h3>
        <div className="achiv-band-row">
          <div className="colImg achiv-band-col">
            <div className="achiv-img-wrapper">
              <img
                src={require("../assets/img/newsCutting.png")}
                alt="Anandabazar Patrika News Cutting"
                className="achiv-news-img"
                style={{ borderRadius: '8px' }}
              />
              <div className="achiv-news-title">
                Anandabazar Patrika, 6th July, 2020
              </div>
            </div>
          </div>
          <div className="achiv-band-col">
            <p style={{ fontWeight: '600' }}>One of the notable clinical milestones at Modern Diagnostics & Nursing Home Pvt. Ltd. includes the successful management of a complex cancer surgery involving an advanced rectal tumour.</p>
            <p>The patient presented with a large tumour measuring approximately 10 cm, requiring a specialised surgical procedure known as abdomino-perineal excision. This procedure involves complete removal of the affected region along with planned reconstruction of bodily function, and is typically performed in large tertiary hospitals due to its technical complexity.</p>
            <p>At our facility, the surgery was carried out using a minimally invasive surgical approach, following established medical protocols and careful pre-operative planning. The procedure required coordinated surgical expertise, appropriate infrastructure, and structured post-operative care.</p>
            <p>With continuous monitoring and nursing support, the patient experienced reduced post-operative discomfort and a smoother recovery process under medical supervision.</p>
            <p>This case reflects our ability to manage complex surgical conditions responsibly, supported by timely diagnosis, experienced clinical decision-making, and coordinated care — bringing advanced treatment closer to the community we serve.</p>
            <p style={{ fontWeight: '600' }}><FontAwesomeIcon icon={faUserDoctor} size='24px' /> Dr. Avidip De || MBBS, MS (Surgery), Fellowship: GI-HPB Surgery (Tata Medical Center) | LAP APR for cancer surgery first time out side kolkata </p>
            
          </div>
        </div>
      </section>
      <section className='servList'>
        <div className="achiv-band-row">
          <div className="colImg achiv-band-col">
            <h2>Services offered at present</h2>
            <ul className="serv-present-list">
              <li><FontAwesomeIcon icon={faCirclePlus} size="sm" style={{ color: '#3FB7E9', marginRight: '8px' }} />CT scan (16 slice multi detector CT scanner with automatic injector)</li>
              <li><FontAwesomeIcon icon={faCirclePlus} size="sm" style={{ color: '#3FB7E9', marginRight: '8px' }} />24 Hrs. Holter Monitoring</li>
              <li><FontAwesomeIcon icon={faCirclePlus} size="sm" style={{ color: '#3FB7E9', marginRight: '8px' }} />EEG</li>
              <li><FontAwesomeIcon icon={faCirclePlus} size="sm" style={{ color: '#3FB7E9', marginRight: '8px' }} />PFT</li>
              <li><FontAwesomeIcon icon={faCirclePlus} size="sm" style={{ color: '#3FB7E9', marginRight: '8px' }} />Endoscopy</li>
              <li><FontAwesomeIcon icon={faCirclePlus} size="sm" style={{ color: '#3FB7E9', marginRight: '8px' }} />colonoscopy</li>
              <li><FontAwesomeIcon icon={faCirclePlus} size="sm" style={{ color: '#3FB7E9', marginRight: '8px' }} />X ray (Digital)</li>
              <li><FontAwesomeIcon icon={faCirclePlus} size="sm" style={{ color: '#3FB7E9', marginRight: '8px' }} />USG, ECG, Echocardiography</li>
              <li><FontAwesomeIcon icon={faCirclePlus} size="sm" style={{ color: '#3FB7E9', marginRight: '8px' }} />Pathology</li>
              <li><FontAwesomeIcon icon={faCirclePlus} size="sm" style={{ color: '#3FB7E9', marginRight: '8px' }} />FNAC, Biochemistry and Microbiology</li>
              <li><FontAwesomeIcon icon={faCirclePlus} size="sm" style={{ color: '#3FB7E9', marginRight: '8px' }} />Endoscopy</li>
              <li><FontAwesomeIcon icon={faCirclePlus} size="sm" style={{ color: '#3FB7E9', marginRight: '8px' }} />Doctor’s chamber</li>
              <li><FontAwesomeIcon icon={faCirclePlus} size="sm" style={{ color: '#3FB7E9', marginRight: '8px' }} />In-patient services</li>
              <li><FontAwesomeIcon icon={faCirclePlus} size="sm" style={{ color: '#3FB7E9', marginRight: '8px' }} />Histopathology</li>
              <li><FontAwesomeIcon icon={faCirclePlus} size="sm" style={{ color: '#3FB7E9', marginRight: '8px' }} />Medical Oncology (Chemotherapy)</li>
            </ul>
          </div>
          <div className="colImg achiv-band-col">
            <h2>For improved services</h2>
            <ul className="serv-present-list">
              <li><FontAwesomeIcon icon={faCirclePlus} size="sm" style={{ color: '#3FB7E9', marginRight: '8px' }} />Commissioned ‘GE Revolution ACTs EX’ 16-slice multidetector CT scanner and ‘Medrad’ automatic injector for performing complex and high-quality CT scans in lesser time</li>
              <li><FontAwesomeIcon icon={faCirclePlus} size="sm" style={{ color: '#3FB7E9', marginRight: '8px' }} />Commissioned ‘Olympus Visera Elite’ HD laparoscopic system and ‘Covidien Ligasure’ vessel sealing system for performing advanced laparoscopic surgeries</li>
              <li><FontAwesomeIcon icon={faCirclePlus} size="sm" style={{ color: '#3FB7E9', marginRight: '8px' }} />Commissioned ‘Siemens Multimobil 5E’ C-Arm for performing advanced orthopaedic surgeries</li>
              <li><FontAwesomeIcon icon={faCirclePlus} size="sm" style={{ color: '#3FB7E9', marginRight: '8px' }} />Commissioned ‘Agfa CR-30Xm’ digitizer system and ‘Agfa Axys’ image printer for obtaining high quality radiology images</li>
            </ul>
          </div>
          <div className="colImg achiv-band-col">
            <h2>OPD Timings</h2>
            <ul className="serv-present-list">
              <li><FontAwesomeIcon icon={faAlarmClock} size="sm" style={{ color: '#3FB7E9', marginRight: '8px' }} />Dr. G S De (Mon to Sat)</li>
              <li><FontAwesomeIcon icon={faAlarmClock} size="sm" style={{ color: '#3FB7E9', marginRight: '8px' }} />Dr. Avidip De</li>
              <li><FontAwesomeIcon icon={faAlarmClock} size="sm" style={{ color: '#3FB7E9', marginRight: '8px' }} />GI and advanced laparoscopic surgeries (Sun to Thurs)</li>
              <li><FontAwesomeIcon icon={faAlarmClock} size="sm" style={{ color: '#3FB7E9', marginRight: '8px' }} />Paediatric Surgery (every Sun)</li>
              <li><FontAwesomeIcon icon={faAlarmClock} size="sm" style={{ color: '#3FB7E9', marginRight: '8px' }} />Plastic surgery (every Sun)</li>
              <li><FontAwesomeIcon icon={faAlarmClock} size="sm" style={{ color: '#3FB7E9', marginRight: '8px' }} />Gynaecology (Mon to Thurs)</li>
              <li><FontAwesomeIcon icon={faAlarmClock} size="sm" style={{ color: '#3FB7E9', marginRight: '8px' }} />Urology (by appointment)</li>
              <li><FontAwesomeIcon icon={faAlarmClock} size="sm" style={{ color: '#3FB7E9', marginRight: '8px' }} />Endoscopy and Medical Gastroenterology (by appointment)</li>
              <li><FontAwesomeIcon icon={faAlarmClock} size="sm" style={{ color: '#3FB7E9', marginRight: '8px' }} />Cardiology (every Sun)</li>
              <li><FontAwesomeIcon icon={faAlarmClock} size="sm" style={{ color: '#3FB7E9', marginRight: '8px' }} />Medical oncology and chemotherapy</li>
            </ul>
          </div>
          <div className="Img achiv-band-col">
            <img
              src={require("../assets/img/ct-scan.jpeg")}
              alt="CT Scan"
              style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px' }}
            />
          </div>
        </div>
      </section>
      <hr />
    </>
  );
}

export default About;
